import { Pencil, Plus } from '@factorialco/f0-react/icons/app'
import { PostsGroupHeaderQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  group: PostsGroupHeaderQuery['posts']['group']
}

export const buildCommunityHeaderProps = ({ group }: Props) => {
  if (!group) {
    return {
      title: '',
    }
  }

  const canAddPosts = group._policies?.addPosts?.can
  const canLeaveGroup = group._policies?.leave?.can
  const canUpdateGroup = group._policies?.update.can && group.isMember
  const canManageParticipants = canUpdateGroup
  const canArchiveGroup = canUpdateGroup

  const otherActions = [
    canUpdateGroup && {
      label: i18n.t('posts.communities.edit_group'),
      key: 'edit-community',
    },
    canManageParticipants && {
      label: i18n.t('posts.communities.add_members'),
      key: 'add-members',
    },
    canManageParticipants && {
      label: i18n.t('posts.communities.remove_members'),
      key: 'remove-members',
    },
    canLeaveGroup && {
      label: i18n.t('posts.communities.leave_group'),
      key: 'leave-group',
    },
    canArchiveGroup && {
      label: i18n.t('posts.communities.delete_group'),
      key: 'delete-community',
      critical: true,
    },
  ].filter(Boolean)

  const primaryAction = canAddPosts
    ? {
        label: i18n.t('new_dashboard.posts.write_post'),
        icon: Pencil,
        key: 'write-post',
      }
    : !group.isMember
    ? {
        label: i18n.t('dashboard.groups.join.submit'),
        icon: Plus,
        key: 'join-group',
      }
    : null

  return {
    title: group.title ?? '',
    description: group.description && group.description !== '-' ? group.description : '',
    status: {
      label: '',
      text: i18n.t('posts.communities.public'),
      variant: 'neutral' as const,
    },
    // TODO: Add members as metadata
    primaryAction,
    otherActions,
  }
}
